import { Component, computed, input } from "@angular/core";
import { GenericSystem } from "../../../../../codegen/out/types";
import { Router } from "@angular/router";

@Component({
  selector: "app-system-thumbnail",
  templateUrl: "./system-thumbnail.component.html",
  styleUrls: ["./system-thumbnail.component.scss"],
  standalone: false,
})
export class SystemThumbnailComponent {
  system = input<GenericSystem>();

  systemImageUrl = computed(
    () =>
      this.system().thumbnail.realLife?.url ||
      this.system().thumbnail.schematic?.url
  );

  constructor(private router: Router) {}

  openSystemInNewTab() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/systems/${this.system().id}`])
    );
    window.open(url, "_blank");
  }
}
